export default __webpack_public_path__ + "static/media/Untitled-1-05.5aefe77d.jpg";